module.exports = __webpack_public_path__ + "static/img/money-explain2.dd397023.png";